import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { PropertiesService } from 'app/modules/properties/properties.service';
import { Project } from 'app/modules/projects/projects.types';
import { Note, NotesPaginationRequest } from './notes.types';
import { NotesActions } from './state/actions';
import { Store } from '@ngxs/store';
import { CustomObjectState } from '../custom-objects/state/state';
import { RelatedToType } from 'app/shared/enums';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';

@Injectable({
  providedIn: 'root',
})
export class NotesResolver {
  constructor(
    private readonly _projectsService: ProjectsService,
    private readonly _propertiesService: PropertiesService,
    private readonly store: Store,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Note[] | void> {
    let filter: NotesPaginationRequest = {
      perPage: 10,
      page: 0,
      noteableType: '',
      noteableId: null,
    };

    if (Object.keys(route.params).filter((param) => ['relatedToKey', 'recordId'].includes(param))?.length) {
      filter.noteableId = route.params.recordId;

      const obj = this.store
        .selectSnapshot(ObjectsManagerState.get)
        .find((x) => x.uiConfig.urlPrefix === route.params.relatedToKey);
      filter.noteableType = obj.name.includes('co_')
        ? RelatedToType.CustomObjectValue
        : obj.name;
      return this.store.dispatch(new NotesActions.GetNotes(filter));
    }

    if (/\/projects\//g.test(state.url)) {
      this._projectsService.project$.subscribe((project: Project) => {
        filter.noteableId = Number(project.id);
        filter.noteableType = RelatedToType.Project;
      });
    } else if (/\/properties\//g.test(state.url)) {
      this._propertiesService.property$.subscribe((property: any) => {
        filter.noteableId = Number(property.id);
        filter.noteableType = RelatedToType.Property;
      });
    } else if (/\/objects\//g.test(state.url)) {
      filter.noteableId = this.store.selectSnapshot(CustomObjectState.getValueById).id;
      filter.noteableType = RelatedToType.CustomObjectValue;
    }

    return this.store.dispatch(new NotesActions.GetNotes(filter));
  }
}

@Injectable({
  providedIn: 'root',
})
export class NoteResolver {
  constructor(private readonly store: Store) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Note | void> {
    return this.store.dispatch(new NotesActions.GetNoteById(Number(route.paramMap.get('id'))));
  }
}
